import jwtDecode from 'jwt-decode';
import { IUserDataToken } from './types';

/**
 * Verifica si un token JWT está expirado
 * @param token - Token JWT a verificar
 * @param marginMinutes - Margen de tiempo en minutos antes de la expiración (default: 0)
 * @returns true si el token está expirado o expirará pronto
 */
export const isTokenExpired = (token: string | null): boolean => {
    if (!token) return true;

    try {
        const userToken: IUserDataToken = jwtDecode(token);
        const actualDateInSeconds = Math.floor(Date.now() / 1000);
        const marginSeconds = userToken.exp;

        return actualDateInSeconds >= marginSeconds;
    } catch (error) {
        console.error('Error verificando expiración de token:', error);
        return true;
    }
};

/**
 * Verifica si un token JWT necesita renovación (con margen de tiempo)
 * @param token - Token JWT a verificar
 * @param marginMinutes - Margen de tiempo en minutos antes de la expiración (default: 5)
 * @returns true si el token necesita renovación
 */
export const shouldRefreshToken = (token: string | null): boolean => isTokenExpired(token);

/**
 * Obtiene el tiempo restante hasta la expiración del token en minutos
 * @param token - Token JWT
 * @returns Tiempo restante en minutos, o null si hay error
 */
export const getTokenTimeRemaining = (token: string | null): number | null => {
    if (!token) return null;

    try {
        const userToken: IUserDataToken = jwtDecode(token);
        const actualDateInSeconds = Math.floor(Date.now() / 1000);
        const timeRemaining = Number(userToken.exp) - actualDateInSeconds;

        return Math.max(0, Math.floor(timeRemaining / 60)); // Convertir a minutos
    } catch (error) {
        console.error('Error obteniendo tiempo restante del token:', error);
        return null;
    }
};
